import Mutations from '../../odata/mutations';

export default { ...new Mutations('tariffCode'), ...new Mutations('tariffCodes') };
